function formatDate(date) {
    const options = {
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric', 
        hour: 'numeric', 
        minute: 'numeric', 
        timeZoneName: 'short',
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    console.log(date);

    const formattedDate = formatter.format(date);

    // Add suffix to the day (st, nd, rd, th)
    const day = date.getDate();
    const daySuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    // Replace the day part with the suffixed version
    return formattedDate.replace(/\d+/, day + daySuffix(day));
}

export default formatDate;
